import { render, staticRenderFns } from "./AboutUsFeedbackSection.vue?vue&type=template&id=0c9b74e3&"
import script from "./AboutUsFeedbackSection.vue?vue&type=script&lang=js&"
export * from "./AboutUsFeedbackSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsFeedbackSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports